<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>local_dining</md-icon>
      </div>
      <h4 class="title">
        Dinners
      </h4>
      <md-button
        class="md-dense md-primary"
        @click="addAllDays()"
        style="margin-top: 1rem"
      >
        <md-icon>add</md-icon>
        Create all Dates
      </md-button>
      <md-button
        class="md-dense md-primary"
        @click="addDay()"
        style="margin-top: 1rem"
      >
        <md-icon>add</md-icon>
        Add a Dinner
      </md-button>
    </md-card-header>
    <md-card-content>
      <!-- <md-table v-model="this.manifest.dinners" md-card> -->
      <md-table v-model="sortedDinners" md-card>
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="Reservation #">
            <md-field>
              <md-input
                v-model="item.reservation_number"
                type="text"
              ></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="Confirmed">
            <md-switch v-model="item.confirmed"></md-switch>
          </md-table-cell>
          <md-table-cell md-label="Date" class="col-date">
            <md-field class="reservation-date">
              <md-input v-model="item.date" type="date"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="Night of" class="col-day">
            <span v-if="item.date">{{ item.date | getDayFromDate }}</span>
          </md-table-cell>
          <md-table-cell md-label="Booking Time">
            <md-field>
              <md-input v-model="item.time" type="time"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="Restaurant">
            <md-field class="option-select">
              <md-input
                :value="getDinnerSearch(item)"
                :list="restaurantListId"
                @input="setDinnerSearch(item, $event)"
                @change="applyDinnerSearch(item)"
                @blur="applyDinnerSearch(item)"
              ></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="Notes">
            <md-field>
              <md-input v-model="item.notes" type="text"></md-input>
            </md-field>
          </md-table-cell>
          <md-table-cell md-label="Actions">
            <md-button
              class="md-danger md-just-icon md-simple"
              @click.stop="removeItem(item)"
            >
              <md-icon>delete</md-icon>
              <md-tooltip md-direction="top">Remove Entry</md-tooltip>
            </md-button>
          </md-table-cell>
        </md-table-row>
        <!-- </md-table-body> -->
        <md-table-empty-state
          md-label="Nothing to Show"
          :md-description="`We can't find any details to show.`"
        >
        </md-table-empty-state>
      </md-table>
      <datalist :id="restaurantListId">
        <option
          v-for="restaurant in restaurants"
          :key="restaurant.id"
          :value="restaurant.company"
        ></option>
      </datalist>
      <reservation-actions
        :departure-id="departure && departure.id"
        section="dinners"
        :rows.sync="manifest.dinners"
        :prepare="prepareReservations"
      />
    </md-card-content>
  </md-card>
</template>

<script>
import ReservationActions from "./ReservationActions.vue";
import restaurantApi from "@/services/api/restaurant";
import moment from "moment";
import { getMissingDepartureDates } from "@/helpers/reservations";

export default {
  components: { ReservationActions },
  props: {
    manifest: {
      itinerary: [],
      dinners: [],
      reservations: []
    },
    departure: {}
  },

  data() {
    return {
      restaurants: [],
      dinnerSearchMap: new WeakMap()
    };
  },

  computed: {
    restaurantListId() {
      return `restaurant-list-${this._uid}`;
    },

    sortedDinners() {
      return this.manifest.dinners
        .slice()
        .sort((a, b) => (Date.parse(a.date) || 0) - (Date.parse(b.date) || 0));
    }
  },

  methods: {
    addAllDays() {
      const existingDates = (this.manifest.dinners || []).map(
        dinner => dinner.date
      );
      getMissingDepartureDates(
        this.departure.start_date,
        this.departure.end_date,
        existingDates
      ).forEach(this.addDay);
    },

    addDay(date = null) {
      this.manifest.dinners.push({
        date: date ? moment().format(date) : moment().format("YYYY-MM-DD"),
        restaurant_id: null,
        reservation_number: "",
        confirmed: false,
        time: "",
        notes: ""
      });
    },

    removeItem: function(item) {
      this.manifest.dinners.splice(this.manifest.dinners.indexOf(item), 1);
    },

    setDinnerSearch(item, value) {
      this.dinnerSearchMap.set(item, value);
    },

    getDinnerSearch(item) {
      if (this.dinnerSearchMap.has(item)) {
        return this.dinnerSearchMap.get(item);
      }
      if (!item.restaurant_id || !this.restaurants.length) return "";
      const match = this.restaurants.find(
        restaurant => restaurant.id === item.restaurant_id
      );
      return match ? match.company : "";
    },

    applyDinnerSearch(item) {
      const search = (this.getDinnerSearch(item) || "").trim().toLowerCase();
      if (!search) {
        item.restaurant_id = null;
        return;
      }
      const match = this.restaurants.find(
        restaurant => restaurant.company?.toLowerCase() === search
      );
      item.restaurant_id = match ? match.id : null;
    },

    prepareReservations() {
      this.manifest.dinners.forEach(item => {
        if (this.dinnerSearchMap.has(item)) this.applyDinnerSearch(item);
      });
    }
  },

  created() {
    restaurantApi.getRestaurants().then(response => {
      this.restaurants = response.data || [];
    });
  }
};
</script>

<style lang="scss" scoped>
.col-day {
  min-width: 90px;
}
.col-date {
  width: 1%;
  white-space: nowrap;
}

.reservation-date {
  width: max-content;
  min-width: 0;
}

.reservation-date ::v-deep .md-input {
  flex: 0 0 auto;
  width: auto;
  min-width: 0;
}
</style>
